import React, { useState } from "react";
import { Container, Nav } from "react-bootstrap";
import EFacturaList from "./EFacturaList";
import ReceivedInvoices from "./ReceivedInvoices";

export default function EFacturaPage() {
  const [tab, setTab] = useState("issued");
  return <Container fluid className="py-3">
    <Nav variant="tabs" activeKey={tab} onSelect={setTab} aria-label="e-Factura">
      <Nav.Item><Nav.Link eventKey="issued">Facturi emise</Nav.Link></Nav.Item>
      <Nav.Item><Nav.Link eventKey="received">Facturi primite</Nav.Link></Nav.Item>
    </Nav>
    {tab === "issued" ? <EFacturaList /> : <ReceivedInvoices />}
  </Container>;
}